// Corteva Crop's flat-fee Consultant invoice — a fixed monthly retainer with
// no pass-through reimbursement (unlike every other Corteva segment): both
// the Consultancy fee and the Service administration charge are ALM's own
// revenue. Two different tax rates apply (4% consultancy tax on the fee,
// 16% GST on the admin charge only), so this doesn't use the generic
// SERVICE_CHARGES_ONLY GST calculator — both tax lines are trusted directly
// from the source doc (computed once, at invoice time, by cortevaTemplate.js
// / the Corteva Crop Consultant page).
import { LINE_CATEGORIES, makeLine } from "../lineCategories";

export function normalizeCortevaCropConsultantInvoice(sourceDoc) {
  const consultancyFee = Number(sourceDoc.consultancyFee || 0);
  const consultancyTax = Number(sourceDoc.consultancyTax || 0);
  const serviceAdminCharge = Number(sourceDoc.serviceAdminCharge || 0);
  const gstOnAdmin = Number(sourceDoc.gstOnAdmin || 0);
  const gstAmount = consultancyTax + gstOnAdmin;
  const invoiceAmount = consultancyFee + serviceAdminCharge;
  const grossAmount = invoiceAmount + gstAmount;

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "Consultancy fee", amount: consultancyFee, sourceField: "consultancyFee" }),
    makeLine({ category: LINE_CATEGORIES.GST, description: "Consultancy tax @4%", amount: consultancyTax, sourceField: "consultancyTax" }),
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "Service administration charges", amount: serviceAdminCharge, sourceField: "serviceAdminCharge" }),
    makeLine({ category: LINE_CATEGORIES.GST, description: "GST on service administration charges @16%", amount: gstOnAdmin, sourceField: "gstOnAdmin" })
  ];

  return {
    lines,
    serviceChargeSubtotal: invoiceAmount,
    invoiceAmount,
    gstAmount,
    grossAmount,
    recoveryBase: null,
    recoveryAddBack: null
  };
}
